import { InventoryActionTypes } from './constants';

export const INIT_STATE = {
    loadingInventory: false,
    error: null,
    inventory: null,
    creatingInventory: false,
    createdInventory: null,
    deletingInventory: false,
    deletedInventory: false,
    updatingInventory: false,
    updatedInventory: null,
    initialInventory: {
        productId: null,
        locationId: null,
        onHand: null,
        available: null,
        allocated: null,
        reorder: null,
        awaiting: null,
        sellable: null,
        unsellable: null,
    },
};

type InventoryAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

//TODO: define data type for orders
type State = {
    loadingInventory: Boolean,
    error?: null,
    inventory: any,
    creatingInventory: Boolean,
    createdInventory: any,
    deletingInventory: Boolean,
    deletedInventory: Boolean,
    updatingInventory: Boolean,
    updatedInventory: any,
    initialInventory: any,
};

const Inventory = (state: State = INIT_STATE, action: InventoryAction): any => {
    switch (action.type) {
        case InventoryActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case InventoryActionTypes.READ_ALL_INVENTORY_REQUEST: {
                    return { ...state, loadingInventory: false, inventory: action.payload.data };
                }
                case InventoryActionTypes.CREATE_INVENTORY_REQUEST: {
                    return { ...state, creatingInventory: false, createdInventory: action.payload.data };
                }
                case InventoryActionTypes.DELETE_INVENTORY_REQUEST: {
                    return { ...state, deletingInventory: false, deletedInventory: true };
                }
                case InventoryActionTypes.UPDATE_INVENTORY_REQUEST: {
                    return { ...state, updatingInventory: false, updatedInventory: action.payload.data };
                }
                default:
                    return { ...state, loadingInventory: false, inventory: null, error: null, creatingInventory: false, createdInventory: null, deletingInventory: false, deletedInventory: false, updatingInventory: false, updatedInventory: null };
            }

        case InventoryActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case InventoryActionTypes.READ_ALL_INVENTORY_REQUEST: {
                    return { ...state, loadingInventory: false, error: action.payload.error };
                }
                case InventoryActionTypes.CREATE_INVENTORY_REQUEST: {
                    return { ...state, creatingInventory: false, error: action.payload.error };
                }
                case InventoryActionTypes.DELETE_INVENTORY_REQUEST: {
                    return { ...state, deletingInventory: false, error: action.payload.error };
                }
                case InventoryActionTypes.UPDATE_INVENTORY_REQUEST: {
                    return { ...state, updatingInventory: false, error: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case InventoryActionTypes.READ_ALL_INVENTORY_REQUEST:
            return { ...state, loadingInventory: true, inventory: null };
        case InventoryActionTypes.CREATE_INVENTORY_REQUEST:
            return { ...state, creatingInventory: true, createdInventory: null };
        case InventoryActionTypes.DELETE_INVENTORY_REQUEST:
            return { ...state, deletingInventory: true, deletedInventory: false };
        case InventoryActionTypes.UPDATE_INVENTORY_REQUEST:
            return { ...state, updatingInventory: true, updatedInventory: null };
        case InventoryActionTypes.RESET_STATE:
            return { ...state, inventory: null, error: null, creatingInventory: false, createdInventory: null, deletingInventory: false, deletedInventory: false, updatingInventory: false, updatedInventory: null };
        case InventoryActionTypes.RESET_ALL_ERRORS:
            return { ...state, error: null };
        default:
            return { ...state };
    }
};

export default Inventory;
